/**
 * ConnectionStatusBanner Component
 * 
 * Shows connection status when offline.
 * - "No internet connection" warning when offline
 * - Auto-hides when back online
 */

import React from 'react';
import { WifiOff } from 'lucide-react';

export default function ConnectionStatusBanner({ isOnline }) {
  if (isOnline) return null;

  return (
    <div 
      data-ui="offline-banner"
      className="bg-amber-500 text-white px-4 py-2 flex items-center justify-center gap-2 text-sm font-medium"
      data-testid="offline-banner"
    >
      <WifiOff className="w-4 h-4" />
      <span>No internet connection</span>
    </div>
  );
}
